var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable prettier/prettier */
import React, { memo, useCallback, useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import LazyLoad from 'react-lazyload';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../../constants/media';
import { FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { API, Endpoints, Lang } from '@brg/api';
import { useAuth, useFingerprintId, useProfile } from '@brg/auth';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from "../../../../../hooks/useCommonProps";
import { FormChoose } from './components/FormChoose';
import { FormsContainer } from './styles';
import { FormView } from './components/FormView';
import { useFormsList } from '../../../../../hooks/useFormsList';
import { LoaderModal } from '../../../../modals/LoaderModal';
import { FORM_POSITION_TYPE } from '../../editor/newel';
import { useForm } from '../../../../../hooks/useForm';
import { OverlayInnerNew } from "../../editor/EditorOverlayNew/styles";
import { CardOverlayInner } from "../../editor/CardOverlay/styles";
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
import { array } from 'prop-types';
var transformArrayToString = function (arr) {
    var result = [];
    arr === null || arr === void 0 ? void 0 : arr.forEach(function (i) { return result.push(i === null || i === void 0 ? void 0 : i.value); });
    return result;
};
export var FORM_RIGHT_POS = '1';
export var FORM_CENTER_POS = '0';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"], ["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"])), function (_a) {
    var blockOffset = _a.blockOffset;
    return blockOffset ? '30px' : 0;
}, OverlayInnerNew, CardOverlayInner);
export var InputTypes = {
    0: 'text',
    1: 'text',
    2: 'email',
    3: 'phone',
    4: 'select',
    5: 'file',
    6: 'text',
    7: 'text',
    8: 'multiple',
    9: 'text'
};
var NEW_TEXT_FORMATTING_THRESHOLD = new Date(2022, 4, 5, 13).getTime();
var DragWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"], ["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"])));
var DragLine = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"], ["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"])));
var DragText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"])));
var VoteAdminWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  background-color: transparent;\n  "], ["\n  width: 100%;\n  background-color: transparent;\n  "])));
var progressAnim = keyframes(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"])));
var LoaderProgressBar = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"], ["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"])), progressAnim);
var OneImgBox = styled(FlexBox)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"], ["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"])));
export var ConditionalLazyLoad = function (_a) {
    var children = _a.children, className = _a.className, isLazy = _a.isLazy;
    if (isLazy)
        return React.createElement(LazyLoad, { offset: 2000, once: true, className: className }, children);
    return React.createElement("div", { className: className }, children);
};
var INITIAL_FORM = { label: 'default', value: 'default' };
var radioItem = [
    { name: 'center', checked: false },
    { name: 'right', checked: false }
];
var INPUTS_PATTERNS = {
    text: /[!@#$%^&*()_]/,
    email: /^\w+@[a-zA-Z_]+?\.[0-9]$/,
    phone: /[A-Za-zА-Яа-я]/
};
var FormsBlock = function (props) {
    var post = props.post, isView = props.isView, isDragging = props.isDragging, isDisabled = props.isDisabled, dragHandleProps = props.dragHandleProps, isDragContinue = props.isDragContinue, colorStyle = props.colorStyle, onSetFormPosition = props.onSetFormPosition, onFormIdSet = props.onFormIdSet, isEditable = props.isEditable, isUpdatePost = props.isUpdatePost, isLoading = props.isLoading;
    var dispatch = useDispatch();
    var auth = useAuth();
    var profile = useProfile();
    var toasts = useToasts();
    var _a = useLocalization(), t = _a.t, language = _a.language;
    var postType = useSelector(function (state) { return state.postType; });
    var container = useRef();
    var is375 = useBreakpoint(375);
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var _b = useCommonProps(), coverContent = _b.coverContent, isFeed = _b.isFeed;
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var _c = useState(INITIAL_FORM), currentForm = _c[0], setCurrentForm = _c[1];
    var _d = useState([
        { name: 'center', checked: true },
        { name: 'right', checked: false }
    ]), radioItem = _d[0], setRadioItem = _d[1];
    var _e = useState([]), formsValues = _e[0], setFormsValues = _e[1];
    var _f = useState(false), isFormEdit = _f[0], setFormEdit = _f[1];
    var _g = useState(false), isLoad = _g[0], setIsLoad = _g[1];
    var _h = useState(true), isPpdAccepted = _h[0], setIsPpdAccepted = _h[1];
    var fingerprintId = useFingerprintId();
    var isUpdating = useMemo(function () { return (post && post.postId === 'updating'); }, [post]);
    var isPostLoading = useMemo(function () { return (post && post.postId === 'loading'); }, [post]);
    var smSize = useMemo(function () { return (isMac13 || smHeight); }, [isMac13, smHeight]);
    var theme = useMemo(function () { return (isView ? colorStyle : 'light'); }, [colorStyle]);
    var formParam = useMemo(function () {
        var _a;
        return ((isView || isUpdatePost) && !isPostLoading && post && ((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.map(function (formParam) {
            var _a;
            var _b = Object.values(formParam), key = _b[0], val = _b[1];
            return _a = {}, _a[key] = val, _a;
        })));
    }, [post, isView, isPostLoading, isUpdatePost]);
    var form = useMemo(function () { return (!!(formParam === null || formParam === void 0 ? void 0 : formParam.length) && (formParam === null || formParam === void 0 ? void 0 : formParam.find(function (i) { return i === null || i === void 0 ? void 0 : i.formId; }))); }, [formParam]);
    var position = useMemo(function () { return (!!(formParam === null || formParam === void 0 ? void 0 : formParam.length) && (formParam === null || formParam === void 0 ? void 0 : formParam.find(function (i) { return i === null || i === void 0 ? void 0 : i.formPosition; }))); }, [formParam]);
    var formsList = useFormsList(isView ? '' : coverContent === null || coverContent === void 0 ? void 0 : coverContent.teamId);
    var _j = useForm(form === null || form === void 0 ? void 0 : form.formId), formView = _j[0], formLoading = _j[1], error = _j[2];
    var setCustomVote = function (id, postId, count) {
        API.request()
            .endpoint(Endpoints.qualities)
            .url('/Like/LikeOnCustomValue')
            .post()
            .body({
            entityId: id,
            entityType: 'superpuperimage',
            count: count
        })
            .send();
    };
    var forms = useMemo(function () { return (!!(formsList === null || formsList === void 0 ? void 0 : formsList.length) ? formsList === null || formsList === void 0 ? void 0 : formsList.reduce(function (acc, val, idx) {
        return __spreadArray(__spreadArray([], acc, true), [{ label: (val === null || val === void 0 ? void 0 : val.techName) || "form-".concat(idx), value: (val === null || val === void 0 ? void 0 : val.formId) || '' }], false);
    }, []) : []); }, [formsList]);
    var handleSetCurrentForm = function (form) {
        setCurrentForm(form);
    };
    var hasForm = useMemo(function () { return ((currentForm === null || currentForm === void 0 ? void 0 : currentForm.label) !== 'default'); }, [currentForm]);
    var completeMsg = useMemo(function () { return (Lang(formView === null || formView === void 0 ? void 0 : formView.textOnComplete, language)); }, [formView, language]);
    var isRequiredFieldsFilled = useMemo(function () { var _a; return !!(formsValues === null || formsValues === void 0 ? void 0 : formsValues.length) && !((_a = formsValues === null || formsValues === void 0 ? void 0 : formsValues.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.isRequired) && !!i.isRequired && (i === null || i === void 0 ? void 0 : i.value) === ''; })) === null || _a === void 0 ? void 0 : _a.length); }, [formsValues]);
    var handleOpenFormEditorClick = function (_a) {
        var value = _a.value;
        if (!hasForm) {
            return toasts.error(t('editor.forms.load.choose_form'));
        }
        setIsLoad(true);
        setTimeout(function () {
            setIsLoad(false);
            window.open(window.location.pathname + "?tab=forms&idform=".concat(value));
        }, [2000]);
    };
    var handleToggleRadioClick = function (name, val) {
        onSetFormPosition(name === 'right' ? FORM_RIGHT_POS : FORM_CENTER_POS);
        setRadioItem(radioItem === null || radioItem === void 0 ? void 0 : radioItem.map(function (btn) {
            btn.checked = false;
            if (btn.name === name) {
                return __assign(__assign({}, btn), { checked: val });
            }
            return btn;
        }));
    };
    var onDropdownChange = function (data, idx, flag) {
        if (!!data) {
            setFormsValues(formsValues.map(function (item, index) {
                if (index === idx) {
                    return !!Array.isArray(data) ? __assign(__assign({}, item), { value: JSON.stringify(transformArrayToString(data)) }) : __assign(__assign({}, item), { value: data });
                }
                return item;
            }));
        }
    };
    var onInputsChange = function (_a, idx) {
        var target = _a.target;
        var value = target.value;
        var type = formsValues[idx].type;
        if (!value.match(INPUTS_PATTERNS[InputTypes[type]])) {
            setFormsValues(formsValues.map(function (item, index) {
                if (index === idx) {
                    return __assign(__assign({}, item), { value: value });
                }
                return item;
            }));
        }
    };
    var clear = function () { return setFormsValues(formsValues === null || formsValues === void 0 ? void 0 : formsValues.map(function (item) { return (__assign(__assign({}, item), { value: '' })); })); };
    var getUtmParams = function () {
        var params = new URLSearchParams(window.location.search);
        var utmTags = {};
        var possibleUtmTags = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content1",
            "utm_term",
            "ym_uid",
            "ym_counter",
            "ga_id",
            "ad_id",
            "adset_id",
            "campaign_id",
            "lead_ad"
        ];
        possibleUtmTags.forEach(function (tag) {
            var value = params.get(tag);
            if (value) {
                utmTags[tag] = value;
            }
        });
        return utmTags;
    };
    var onInputsDataSend = useCallback(function () {
        if ((formView === null || formView === void 0 ? void 0 : formView.isRegisteredUsersOnly) && !profile && isRequiredFieldsFilled) {
            localStorage.setItem('pendingFormData', JSON.stringify({
                formsValues: formsValues,
                formId: form === null || form === void 0 ? void 0 : form.formId,
                completeMsg: completeMsg
            }));
            return auth.login();
        }
        if (isRequiredFieldsFilled) {
            var data = formsValues === null || formsValues === void 0 ? void 0 : formsValues.reduce(function (acc, val) {
                return __spreadArray(__spreadArray([], acc, true), [
                    {
                        type: val.type,
                        header: Lang(val.header, language),
                        response: val.value
                    }
                ], false);
            }, []);
            return (API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/forms/AddFormAnswer')
                .post()
                .body({
                formId: form === null || form === void 0 ? void 0 : form.formId,
                utmTags: [''],
                pageUrl: window.location.href,
                formAnswerFields: data,
                metaData: getUtmParams(),
                isPpdAccepted: isPpdAccepted
            })
                .send()
                .then(function (r) {
                toasts.info(completeMsg || t('editor.forms.success'));
                clear();
            }));
        }
        toasts.error(t('editor.forms.msg.required'));
    }, [isRequiredFieldsFilled, formsValues, language]);
    useEffect(function () {
        var checkPendingForm = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pendingFormData, _a, formsValues_1, formId, completeMsg_1, data, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pendingFormData = localStorage.getItem('pendingFormData');
                        if (!(profile && pendingFormData)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = JSON.parse(pendingFormData), formsValues_1 = _a.formsValues, formId = _a.formId, completeMsg_1 = _a.completeMsg;
                        data = formsValues_1 === null || formsValues_1 === void 0 ? void 0 : formsValues_1.reduce(function (acc, val) {
                            return __spreadArray(__spreadArray([], acc, true), [
                                {
                                    type: val.type,
                                    header: Lang(val.header, language),
                                    response: val.value
                                }
                            ], false);
                        }, []);
                        return [4 /*yield*/, API.request()
                                .endpoint(Endpoints.geograffee)
                                .url('/api/forms/AddFormAnswer')
                                .post()
                                .body({
                                formId: formId,
                                utmTags: [''],
                                pageUrl: window.location.href,
                                formAnswerFields: data,
                                metaData: getUtmParams(),
                                isPpdAccepted: isPpdAccepted
                            })
                                .send()];
                    case 2:
                        _b.sent();
                        toasts.info(completeMsg_1 || t('editor.forms.success'));
                        localStorage.removeItem('pendingFormData');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        toasts.error(t('editor.forms.error'));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        checkPendingForm();
    }, [profile, language]);
    var loaderText = useMemo(function () {
        if (isLoading || formLoading || isLoad)
            return t('editor.forms.load.form_editor');
        return t('editor.forms.load.saving');
    }, [isLoad, isLoading, isUpdating, formLoading]);
    var showLoader = useMemo(function () { return ((!!isLoading || !!formLoading || !!isLoad || !!isUpdating)); }, [isLoading || formLoading || isLoad]);
    var formPosition = useMemo(function () { return (position && FORM_POSITION_TYPE[Number(position === null || position === void 0 ? void 0 : position.formPosition)]); }, [position]);
    var updatedAt = post && new Date(post.dateLastChange).getTime();
    var hasNewFormatting = updatedAt > NEW_TEXT_FORMATTING_THRESHOLD;
    useEffect(function () {
        var _a;
        if (formView) {
            var fields = (_a = formView.formFields) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, val) {
                return __spreadArray(__spreadArray([], acc, true), [
                    __assign(__assign({}, val), { type: val.type, value: '' })
                ], false);
            }, []);
            setFormsValues(fields);
        }
    }, [formView]);
    useEffect(function () {
        if (formView && isUpdatePost) {
            setCurrentForm({ label: formView === null || formView === void 0 ? void 0 : formView.techName, value: formView === null || formView === void 0 ? void 0 : formView.formId });
        }
    }, [formView, isUpdatePost]);
    useEffect(function () {
        if (currentForm && hasForm) {
            onFormIdSet(currentForm === null || currentForm === void 0 ? void 0 : currentForm.value);
        }
    }, [currentForm, hasForm]);
    if (!!error) {
        return null;
    }
    return (React.createElement(Wrap, null,
        showLoader && React.createElement(LoaderModal, { placeholder: loaderText }),
        React.createElement(GeneralEditorOverlay, { isEditable: isEditable, isLoading: isLoading, withoutDrag: isFeed, post: post, dragHandleProps: dragHandleProps }),
        React.createElement(FormsContainer, { colorStyle: !isView ? 'light' : theme, position: formPosition, isView: isView }, !isLoad && (React.createElement(React.Fragment, null, isView ? (React.createElement(FormView, { onSend: onInputsDataSend, form: formView, inputsValues: formsValues, colorStyle: theme, isEditable: isEditable, onInputsChange: onInputsChange, onDropdownChange: onDropdownChange, position: position, isDisabled: isDisabled, isPpdAccepted: isPpdAccepted, setIsPpdAccepted: setIsPpdAccepted })) : (React.createElement(FormChoose, { forms: forms, form: currentForm, radio: radioItem, onSetForm: handleSetCurrentForm, onEdit: handleOpenFormEditorClick, onRadioChange: handleToggleRadioClick, onFormIdSet: onFormIdSet }))))),
        !isDragging && isDragContinue && (React.createElement(DragWrap, { className: 'drag__hide' },
            React.createElement(DragLine, null),
            React.createElement(DragText, null, "Drop to place")))));
};
export default memo(FormsBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=FormsBlock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable prettier/prettier */
import React, { memo, useCallback, useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import LazyLoad from 'react-lazyload';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../../constants/media';
import { FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { API, Endpoints, Lang } from '@brg/api';
import { useAuth, useFingerprintId, useProfile } from '@brg/auth';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from "../../../../../hooks/useCommonProps";
import { FormChoose } from './components/FormChoose';
import { FormsContainer } from './styles';
import { FormView } from './components/FormView';
import { useFormsList } from '../../../../../hooks/useFormsList';
import { LoaderModal } from '../../../../modals/LoaderModal';
import { FORM_POSITION_TYPE } from '../../editor/newel';
import { useForm } from '../../../../../hooks/useForm';
import { OverlayInnerNew } from "../../editor/EditorOverlayNew/styles";
import { CardOverlayInner } from "../../editor/CardOverlay/styles";
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
import { array } from 'prop-types';
var transformArrayToString = function (arr) {
    var result = [];
    arr === null || arr === void 0 ? void 0 : arr.forEach(function (i) { return result.push(i === null || i === void 0 ? void 0 : i.value); });
    return result;
};
export var FORM_RIGHT_POS = '1';
export var FORM_CENTER_POS = '0';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"], ["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"])), function (_a) {
    var blockOffset = _a.blockOffset;
    return blockOffset ? '30px' : 0;
}, OverlayInnerNew, CardOverlayInner);
export var InputTypes = {
    0: 'text',
    1: 'text',
    2: 'email',
    3: 'phone',
    4: 'select',
    5: 'file',
    6: 'text',
    7: 'text',
    8: 'multiple',
    9: 'text'
};
var NEW_TEXT_FORMATTING_THRESHOLD = new Date(2022, 4, 5, 13).getTime();
var DragWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"], ["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"])));
var DragLine = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"], ["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"])));
var DragText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"])));
var VoteAdminWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  background-color: transparent;\n  "], ["\n  width: 100%;\n  background-color: transparent;\n  "])));
var progressAnim = keyframes(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"])));
var LoaderProgressBar = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"], ["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"])), progressAnim);
var OneImgBox = styled(FlexBox)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"], ["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"])));
export var ConditionalLazyLoad = function (_a) {
    var children = _a.children, className = _a.className, isLazy = _a.isLazy;
    if (isLazy)
        return React.createElement(LazyLoad, { offset: 2000, once: true, className: className }, children);
    return React.createElement("div", { className: className }, children);
};
var INITIAL_FORM = { label: 'default', value: 'default' };
var radioItem = [
    { name: 'center', checked: false },
    { name: 'right', checked: false }
];
var INPUTS_PATTERNS = {
    text: /[!@#$%^&*()_]/,
    email: /^\w+@[a-zA-Z_]+?\.[0-9]$/,
    phone: /[A-Za-zА-Яа-я]/
};
var FormsBlock = function (props) {
    var post = props.post, isView = props.isView, isDragging = props.isDragging, isDisabled = props.isDisabled, dragHandleProps = props.dragHandleProps, isDragContinue = props.isDragContinue, colorStyle = props.colorStyle, onSetFormPosition = props.onSetFormPosition, onFormIdSet = props.onFormIdSet, isEditable = props.isEditable, isUpdatePost = props.isUpdatePost, isLoading = props.isLoading;
    var dispatch = useDispatch();
    var auth = useAuth();
    var profile = useProfile();
    var toasts = useToasts();
    var _a = useLocalization(), t = _a.t, language = _a.language;
    var postType = useSelector(function (state) { return state.postType; });
    var container = useRef();
    var is375 = useBreakpoint(375);
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var _b = useCommonProps(), coverContent = _b.coverContent, isFeed = _b.isFeed;
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var _c = useState(INITIAL_FORM), currentForm = _c[0], setCurrentForm = _c[1];
    var _d = useState([
        { name: 'center', checked: true },
        { name: 'right', checked: false }
    ]), radioItem = _d[0], setRadioItem = _d[1];
    var _e = useState([]), formsValues = _e[0], setFormsValues = _e[1];
    var _f = useState(false), isFormEdit = _f[0], setFormEdit = _f[1];
    var _g = useState(false), isLoad = _g[0], setIsLoad = _g[1];
    var _h = useState(true), isPpdAccepted = _h[0], setIsPpdAccepted = _h[1];
    var fingerprintId = useFingerprintId();
    var isUpdating = useMemo(function () { return (post && post.postId === 'updating'); }, [post]);
    var isPostLoading = useMemo(function () { return (post && post.postId === 'loading'); }, [post]);
    var smSize = useMemo(function () { return (isMac13 || smHeight); }, [isMac13, smHeight]);
    var theme = useMemo(function () { return (isView ? colorStyle : 'light'); }, [colorStyle]);
    var formParam = useMemo(function () {
        var _a;
        return ((isView || isUpdatePost) && !isPostLoading && post && ((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.map(function (formParam) {
            var _a;
            var _b = Object.values(formParam), key = _b[0], val = _b[1];
            return _a = {}, _a[key] = val, _a;
        })));
    }, [post, isView, isPostLoading, isUpdatePost]);
    var form = useMemo(function () { return (!!(formParam === null || formParam === void 0 ? void 0 : formParam.length) && (formParam === null || formParam === void 0 ? void 0 : formParam.find(function (i) { return i === null || i === void 0 ? void 0 : i.formId; }))); }, [formParam]);
    var position = useMemo(function () { return (!!(formParam === null || formParam === void 0 ? void 0 : formParam.length) && (formParam === null || formParam === void 0 ? void 0 : formParam.find(function (i) { return i === null || i === void 0 ? void 0 : i.formPosition; }))); }, [formParam]);
    var formsList = useFormsList(isView ? '' : coverContent === null || coverContent === void 0 ? void 0 : coverContent.teamId);
    var _j = useForm(form === null || form === void 0 ? void 0 : form.formId), formView = _j[0], formLoading = _j[1], error = _j[2];
    var setCustomVote = function (id, postId, count) {
        API.request()
            .endpoint(Endpoints.qualities)
            .url('/Like/LikeOnCustomValue')
            .post()
            .body({
            entityId: id,
            entityType: 'superpuperimage',
            count: count
        })
            .send();
    };
    var forms = useMemo(function () { return (!!(formsList === null || formsList === void 0 ? void 0 : formsList.length) ? formsList === null || formsList === void 0 ? void 0 : formsList.reduce(function (acc, val, idx) {
        return __spreadArray(__spreadArray([], acc, true), [{ label: (val === null || val === void 0 ? void 0 : val.techName) || "form-".concat(idx), value: (val === null || val === void 0 ? void 0 : val.formId) || '' }], false);
    }, []) : []); }, [formsList]);
    var handleSetCurrentForm = function (form) {
        setCurrentForm(form);
    };
    var hasForm = useMemo(function () { return ((currentForm === null || currentForm === void 0 ? void 0 : currentForm.label) !== 'default'); }, [currentForm]);
    var completeMsg = useMemo(function () { return (Lang(formView === null || formView === void 0 ? void 0 : formView.textOnComplete, language)); }, [formView, language]);
    var isRequiredFieldsFilled = useMemo(function () { var _a; return !!(formsValues === null || formsValues === void 0 ? void 0 : formsValues.length) && !((_a = formsValues === null || formsValues === void 0 ? void 0 : formsValues.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.isRequired) && !!i.isRequired && (i === null || i === void 0 ? void 0 : i.value) === ''; })) === null || _a === void 0 ? void 0 : _a.length); }, [formsValues]);
    var handleOpenFormEditorClick = function (_a) {
        var value = _a.value;
        if (!hasForm) {
            return toasts.error(t('editor.forms.load.choose_form'));
        }
        setIsLoad(true);
        setTimeout(function () {
            setIsLoad(false);
            window.open(window.location.pathname + "?tab=forms&idform=".concat(value));
        }, [2000]);
    };
    var handleToggleRadioClick = function (name, val) {
        onSetFormPosition(name === 'right' ? FORM_RIGHT_POS : FORM_CENTER_POS);
        setRadioItem(radioItem === null || radioItem === void 0 ? void 0 : radioItem.map(function (btn) {
            btn.checked = false;
            if (btn.name === name) {
                return __assign(__assign({}, btn), { checked: val });
            }
            return btn;
        }));
    };
    var onDropdownChange = function (data, idx, flag) {
        if (!!data) {
            setFormsValues(formsValues.map(function (item, index) {
                if (index === idx) {
                    return !!Array.isArray(data) ? __assign(__assign({}, item), { value: JSON.stringify(transformArrayToString(data)) }) : __assign(__assign({}, item), { value: data });
                }
                return item;
            }));
        }
    };
    var onInputsChange = function (_a, idx) {
        var target = _a.target;
        var value = target.value;
        var type = formsValues[idx].type;
        if (!value.match(INPUTS_PATTERNS[InputTypes[type]])) {
            setFormsValues(formsValues.map(function (item, index) {
                if (index === idx) {
                    return __assign(__assign({}, item), { value: value });
                }
                return item;
            }));
        }
    };
    var clear = function () { return setFormsValues(formsValues === null || formsValues === void 0 ? void 0 : formsValues.map(function (item) { return (__assign(__assign({}, item), { value: '' })); })); };
    var getUtmParams = function () {
        var params = new URLSearchParams(window.location.search);
        var utmTags = {};
        var possibleUtmTags = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content1",
            "utm_term",
            "ym_uid",
            "ym_counter",
            "ga_id",
            "ad_id",
            "adset_id",
            "campaign_id",
            "lead_ad"
        ];
        possibleUtmTags.forEach(function (tag) {
            var value = params.get(tag);
            if (value) {
                utmTags[tag] = value;
            }
        });
        return utmTags;
    };
    var onInputsDataSend = useCallback(function () {
        if ((formView === null || formView === void 0 ? void 0 : formView.isRegisteredUsersOnly) && !profile && isRequiredFieldsFilled) {
            localStorage.setItem('pendingFormData', JSON.stringify({
                formsValues: formsValues,
                formId: form === null || form === void 0 ? void 0 : form.formId,
                completeMsg: completeMsg
            }));
            return auth.login();
        }
        if (isRequiredFieldsFilled) {
            var data = formsValues === null || formsValues === void 0 ? void 0 : formsValues.reduce(function (acc, val) {
                return __spreadArray(__spreadArray([], acc, true), [
                    {
                        type: val.type,
                        header: Lang(val.header, language),
                        response: val.value
                    }
                ], false);
            }, []);
            return (API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/forms/AddFormAnswer')
                .post()
                .body({
                formId: form === null || form === void 0 ? void 0 : form.formId,
                utmTags: [''],
                pageUrl: window.location.href,
                formAnswerFields: data,
                metaData: getUtmParams(),
                isPpdAccepted: isPpdAccepted
            })
                .send()
                .then(function (r) {
                toasts.info(completeMsg || t('editor.forms.success'));
                clear();
            }));
        }
        toasts.error(t('editor.forms.msg.required'));
    }, [isRequiredFieldsFilled, formsValues, language]);
    useEffect(function () {
        var checkPendingForm = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pendingFormData, _a, formsValues_1, formId, completeMsg_1, data, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pendingFormData = localStorage.getItem('pendingFormData');
                        if (!(profile && pendingFormData)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = JSON.parse(pendingFormData), formsValues_1 = _a.formsValues, formId = _a.formId, completeMsg_1 = _a.completeMsg;
                        data = formsValues_1 === null || formsValues_1 === void 0 ? void 0 : formsValues_1.reduce(function (acc, val) {
                            return __spreadArray(__spreadArray([], acc, true), [
                                {
                                    type: val.type,
                                    header: Lang(val.header, language),
                                    response: val.value
                                }
                            ], false);
                        }, []);
                        return [4 /*yield*/, API.request()
                                .endpoint(Endpoints.geograffee)
                                .url('/api/forms/AddFormAnswer')
                                .post()
                                .body({
                                formId: formId,
                                utmTags: [''],
                                pageUrl: window.location.href,
                                formAnswerFields: data,
                                metaData: getUtmParams(),
                                isPpdAccepted: isPpdAccepted
                            })
                                .send()];
                    case 2:
                        _b.sent();
                        toasts.info(completeMsg_1 || t('editor.forms.success'));
                        localStorage.removeItem('pendingFormData');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        toasts.error(t('editor.forms.error'));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        checkPendingForm();
    }, [profile, language]);
    var loaderText = useMemo(function () {
        if (isLoading || formLoading || isLoad)
            return t('editor.forms.load.form_editor');
        return t('editor.forms.load.saving');
    }, [isLoad, isLoading, isUpdating, formLoading]);
    var showLoader = useMemo(function () { return ((!!isLoading || !!formLoading || !!isLoad || !!isUpdating)); }, [isLoading || formLoading || isLoad]);
    var formPosition = useMemo(function () { return (position && FORM_POSITION_TYPE[Number(position === null || position === void 0 ? void 0 : position.formPosition)]); }, [position]);
    var updatedAt = post && new Date(post.dateLastChange).getTime();
    var hasNewFormatting = updatedAt > NEW_TEXT_FORMATTING_THRESHOLD;
    useEffect(function () {
        var _a;
        if (formView) {
            var fields = (_a = formView.formFields) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, val) {
                return __spreadArray(__spreadArray([], acc, true), [
                    __assign(__assign({}, val), { type: val.type, value: '' })
                ], false);
            }, []);
            setFormsValues(fields);
        }
    }, [formView]);
    useEffect(function () {
        if (formView && isUpdatePost) {
            setCurrentForm({ label: formView === null || formView === void 0 ? void 0 : formView.techName, value: formView === null || formView === void 0 ? void 0 : formView.formId });
        }
    }, [formView, isUpdatePost]);
    useEffect(function () {
        if (currentForm && hasForm) {
            onFormIdSet(currentForm === null || currentForm === void 0 ? void 0 : currentForm.value);
        }
    }, [currentForm, hasForm]);
    if (!!error) {
        return null;
    }
    return (React.createElement(Wrap, null,
        showLoader && React.createElement(LoaderModal, { placeholder: loaderText }),
        React.createElement(GeneralEditorOverlay, { isEditable: isEditable, isLoading: isLoading, withoutDrag: isFeed, post: post, dragHandleProps: dragHandleProps }),
        React.createElement(FormsContainer, { colorStyle: !isView ? 'light' : theme, position: formPosition, isView: isView }, !isLoad && (React.createElement(React.Fragment, null, isView ? (React.createElement(FormView, { onSend: onInputsDataSend, form: formView, inputsValues: formsValues, colorStyle: theme, isEditable: isEditable, onInputsChange: onInputsChange, onDropdownChange: onDropdownChange, position: position, isDisabled: isDisabled, isPpdAccepted: isPpdAccepted, setIsPpdAccepted: setIsPpdAccepted })) : (React.createElement(FormChoose, { forms: forms, form: currentForm, radio: radioItem, onSetForm: handleSetCurrentForm, onEdit: handleOpenFormEditorClick, onRadioChange: handleToggleRadioClick, onFormIdSet: onFormIdSet }))))),
        !isDragging && isDragContinue && (React.createElement(DragWrap, { className: 'drag__hide' },
            React.createElement(DragLine, null),
            React.createElement(DragText, null, "Drop to place")))));
};
export default memo(FormsBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=FormsBlock.js.map